import ConsultantList from './ConsultantList';

export default ConsultantList;
